import { Context, createStore, ExtendedModel, model, override } from '@weavix/mobx';
import { myUserId } from '../my-profile-store/my-profile-store';
import { FacilityPerson } from './facility-people.model';
import { channelsContext } from 'models-mobx/channels-store/channels-store';

const base = createStore<FacilityPerson>('facility-people', FacilityPerson);
const getFullId = (facilityId, personId) => `${facilityId}-${personId}`;

export const facilityPeopleContext = base.context as Context<FacilityPeopleStore>;
export const facilityPeopleRef = base.ref;

export const getFacilityPerson = (facilityId: string, personId = myUserId()) => {
    return facilityPeopleContext.get().get(getFullId(facilityId, personId));
};

@model('FacilityPeopleStore')
export class FacilityPeopleStore extends ExtendedModel(base.Store, {
}) {
    getPerson(personId: string, facilityId: string) {
        return this.getStatic(getFullId(facilityId, personId));
    }

    @override
    updateValue(value: any, keys?: any) {
        super.updateValue(value, keys);
        const accountId = value.accountId ?? value.partition;
        if (accountId) this.clearAdcCache(accountId);
    }

    @override
    deleteValue(value: any) {
        super.deleteValue(value);
        const accountId = value.accountId ?? value.partition;
        if (accountId) this.clearAdcCache(accountId);
    }

    private clearAdcCache(accountId: string) {
        const adcChannels = channelsContext.getDefault().channels?.filter(x => x.accountId === accountId);
        adcChannels?.forEach(channel => {
            channel.clearUserCache();
        });
    }
}
